export class StepConfig {
    public displayName: string;
    public step: string;
    public isActive: boolean;

    public hideNextButton: boolean;
    public hidePreviousButton: boolean;
    public hidePriceInformation: boolean;

    constructor(displayName: string, step: string) {
        this.displayName = displayName;
        this.step = step;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/step-config.model.ts